module.exports = __webpack_public_path__ + "static/media/onBoardingCommon.dbeb1e5a.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Onboarding/onBoardingCommon.scss
// module id = 2084
// module chunks = 0